import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import brandLogo from '../../assets/img/brand-logo.svg';
import humanstxtLogo from '../../assets/img/humanstxt.png';

import '../../assets/css/footer.css';

const Footer = () => {
    return (
        <footer>
            <div className="wrapper">
                <div className='rows'>
                    <div className='row'>
                        <img className="brand-logo" src={brandLogo} alt="NGCTV Logo" title="NGCTV Logo"/>
                        <span className='copyright'>&copy; 2025 ngctv.de</span>
                    </div>
                    <div className='row'>
                        <ul>
                            <li><Link to="/impressum" viewTransition>Impressum</Link></li>
                            <li><Link to="/nutzungsbestimmungen" viewTransition>Nutzungsbestimmungen</Link></li>
                            <li><Link to="/datenschutz" viewTransition>Datenschutzerklärung</Link></li>
                        </ul>
                    </div>
                    <div className='row'>
                        <ul>
                            <li><Link to="/info" viewTransition>Über Uns</Link></li>
                            <li><Link to="/team" viewTransition>Unser Team</Link></li>
                            <li><Link to="/kontakt" viewTransition>Kontakt</Link></li>
                        </ul>
                    </div>
                    <div className='row'>
                        <ul>
                            <li><Link to="/login" viewTransition>Login</Link></li>
                            <li><Link to="/community/Neuigkeiten/1" viewTransition>Regeln</Link></li>
                            <li><Link to="/karriere" viewTransition>Karriere</Link></li>
                        </ul>
                    </div>
                    <div className='row'>

                    </div>
                </div>
                <div className='humansTxt'>
                    <a href="/humans.txt">
                        <img src={humanstxtLogo} alt='humans.txt' title='humans.txt'></img>
                    </a>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
